export type SeasonMilestone = { level: number; xpRequired: number; rewardFishies: number };

export const SEASON_MILESTONES: readonly SeasonMilestone[] = [
  { level: 1, xpRequired: 25, rewardFishies: 20 },
  { level: 2, xpRequired: 60, rewardFishies: 30 },
  { level: 3, xpRequired: 110, rewardFishies: 40 },
  { level: 4, xpRequired: 180, rewardFishies: 55 },
  { level: 5, xpRequired: 270, rewardFishies: 75 },
  { level: 6, xpRequired: 390, rewardFishies: 100 },
  { level: 7, xpRequired: 540, rewardFishies: 130 },
  { level: 8, xpRequired: 730, rewardFishies: 170 },
  { level: 9, xpRequired: 960, rewardFishies: 220 },
  { level: 10, xpRequired: 1250, rewardFishies: 300 },
];

export function currentSeasonId(nowMs: number): string {
  const d = new Date(nowMs);
  const m = `${d.getUTCMonth() + 1}`.padStart(2, '0');
  return `${d.getUTCFullYear()}-${m}`;
}

export function seasonLevel(xp: number): number {
  let lvl = 0;
  for (const m of SEASON_MILESTONES) if (xp >= m.xpRequired) lvl = m.level;
  return lvl;
}

export function claimableMilestones(xp: number, claimed: readonly number[]): number[] {
  const claimedSet = new Set(claimed);
  return SEASON_MILESTONES.filter((m) => xp >= m.xpRequired && !claimedSet.has(m.level)).map((m) => m.level);
}
